import { createFileRoute, Navigate } from "@tanstack/react-router";
import { usePermissionCheck } from "shared/stores/oidc";
import { Permission } from "src/gql/graphql";

/** @public */
export const Route = createFileRoute("/_auth/ipaws/")({
    component: () => {
        const hasViewAlert = usePermissionCheck(Permission.IpawsHistoryView);
        const hasCertView = usePermissionCheck(Permission.CustomerIpawsManage);

        if (hasViewAlert) return <Navigate to="/ipaws/alerts" />;
        if (hasCertView) return <Navigate to="/ipaws/certificates" />;

        return <Navigate to="/" />;
    },
});
